import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const walletApi = createApi({
  reducerPath: "walletApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + `financial/wallet`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.userSlice?.token; // ✅ بدون store
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  // /topup/init
  endpoints: (builder) => ({
    getWallet: builder.query({
      query: () => {
        return {
          url: "/me",
          method: "GET",
        };
      },
    }),
    sendChargeWallet: builder.mutation({
      query: ({ amount, orderId = null, promoteType = null, gateway }) => {
        return {
          url: "/topup/init",
          method: "POST",
          body: {
            amount,
            orderId: orderId,
            promoteId: promoteType,
            gateway: gateway,
          },
        };
      },
    }),
    checkAndVerifyWalletCharge: builder.query({
      query: (params) => {
        const search = new URLSearchParams(params).toString();
        return {
          url: `/topup/verify?${search}`,
          method: "GET",
        };
      },
    }),
    claimMony: builder.mutation({
      query: ({ amount, bank = null }) => {
        return {
          url: "/withdraw/request",
          method: "POST",
          body: {
            amount,
            bank: bank,
          },
        };
      },
    }),

    getTx: builder.query({
      query: ({ page = 1, limit = 10, sort = "-createdAt" }) => {
        return {
          url: `/me/transactions?page=${page}&limit=${limit}&sort=${sort}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useGetWalletQuery,
  useSendChargeWalletMutation,
  useCheckAndVerifyWalletChargeQuery,
  useLazyCheckAndVerifyWalletChargeQuery,
  useClaimMonyMutation,
  useGetTxQuery,
} = walletApi;
